// extracted by mini-css-extract-plugin
module.exports = {"AttributesItems":"AttributesItems_AttributesItems__2n-TQ"};